/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { FlyoutMenuContentEntryPointProps } from './FlyoutMenuContentEntryPoint.entrypoint.types.tsx';

type FlyoutMenuContentEntryPointComponent = EntryPointComponent<
	{},
	{},
	FlyoutMenuContentEntryPointProps,
	{} | null
>;

export const flyoutMenuContentEntryPoint: EntryPoint<FlyoutMenuContentEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<FlyoutMenuContentEntryPointComponent>(
			/* webpackChunkName: "async-flyout-menu-content" */ './MemoizedBoardCreateFlyoutMenuContent.tsx',
		),
		getPreloadProps: () => ({}),
	});
